import type { ReactNode } from 'react';

export interface PageContainerProps {
    children: ReactNode;
    /** False drops the top and bottom padding, for a container inside a band that sets its own. */
    verticalPadding?: boolean;
    /** Fills the main region's height as a column, so a fill-height page can size its scroll box. */
    fillHeight?: boolean;
}

/** The page width and side padding every page shares. */
export function PageContainer({ children, verticalPadding = true, fillHeight = false }: PageContainerProps) {
    return (
        <div
            className={`mx-auto max-w-(--breakpoint-2xl) px-4 md:px-6 ${verticalPadding ? 'py-4 md:py-6' : ''} ${
                fillHeight ? 'flex min-h-0 w-full min-w-0 flex-1 flex-col' : ''
            }`}
        >
            {children}
        </div>
    );
}
